/**
 * Header
 * Primary site header: logo, top contact bar, the desktop nav (Home / About /
 * Contact only) and the mobile menu. Cart/search/login were removed by design.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../images/cole-harbour-islamic-society-logo.png';
import HeaderTopbar from '../HeaderTopbar';
import MobileMenu from '../../components/MobileMenu';
import './style.css';

const Header = () => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div className="middle-header">
      <HeaderTopbar />
      <div className="header-style-3">
        <div className="container">
          <div className="header-content">
            <div className="row align-items-center">
              <div className="col-lg-4 col-md-4 col-sm-4 col-8 header-brand-col">
                <div className="logo">
                  <Link onClick={ClickHandler} to="/home" className="logo-link">
                    <img src={Logo} alt="Cole Harbour Masjid" />
                    <p className="site-name">Cole Harbour Masjid</p>
                  </Link>
                </div>
              </div>
              <div className="col-lg-8 d-lg-block d-none">
                <nav>
                  <ul>
                    <li>
                      <Link
                        onClick={ClickHandler}
                        className="active"
                        to="/home"
                        title=""
                      >
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/about" title="">
                        About
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/contact" title="">
                        Contact
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="col-lg-8 col-md-8 col-sm-8 col-4 d-lg-none header-menu-col">
                <MobileMenu />
              </div>
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
